import React, { TextareaHTMLAttributes } from 'react';
import { InputContainer } from './styles';
export interface TextAreaFormFieldProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string,
  value?: string,
  backGround?: string,
  marginBotton?: string,
  name: string,
  error?: boolean,
  mensageError?: string,
  mensagem?: string,
  block?: boolean,
  icon?: boolean,
  iconImg?: JSX.Element,
  animation?: boolean,
  isEncrypted?: boolean,
  currentStateEncrypted?: boolean
  onClick?: () => void,
  onChange: (text: any) => void;
}


export const TextFormField: React.FC<TextAreaFormFieldProps> = ({
  label = "Meu input",
  value,
  backGround = "#fff",
  marginBotton = "40",
  name,
  error = false,
  mensageError = "",
  mensagem = "",
  block = false,
  icon = false,
  iconImg,
  animation = false,
  onChange,
  onClick = () => { },
  ...props }) => {


  return (
    <InputContainer
      icon={icon}
      block={block}
      isError={error}
      animation={animation}
      backGround={backGround}
      marginBotton={marginBotton}
    >
      <div className="formField-input">
        <textarea
          value={value}
          name={name}
          aria-label={name}
          placeholder=" "
          onChange={onChange}
          {...props}
        />

        <label htmlFor={name}>{label}</label>

      </div>

      {error ? <span>{mensageError}</span> : null}
      {!error && mensagem.length > 0 ? <span>{mensagem}</span> : null}

    </InputContainer>
  )
}